import { EDepositStatus } from "src/types";
import { SuccessIcon, ErrorIcon, CancelIcon } from "./icons";
import "./status-deposit.scss";

interface StatusDepositProps {
  status: EDepositStatus;
  title: string;
  message: string;
}

const StatusDeposit: React.FC<StatusDepositProps> = ({ status, title, message }) => {
  const icons = {
    [EDepositStatus.Success]: <SuccessIcon />,
    [EDepositStatus.Error]: <ErrorIcon />,
    [EDepositStatus.Cancel]: <CancelIcon />,
  };

  return (
    <section className="deposit-status-container">
      <div className={`deposit-status-icon deposit-status-icon-${status}`}>{icons[status]}</div>
      <h1 className="deposit-status-title">{title}</h1>
      <p className="deposit-status-message">{message}</p>
    </section>
  );
};

export default StatusDeposit;
